import React, { Component } from 'react';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
  Cell,
} from 'recharts';

import { colors, shadeColor } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

export default class PollResults extends Component {
  totalResponses = () => {
    let totalResponses = 0;
    this.props.results.forEach(response => {
      totalResponses += response.response_count;
    });
    return totalResponses;
  };

  basicLabel = value => {
    let totalNumberOfResponses = 1;
    if (this.totalResponses() > 0) {
      totalNumberOfResponses = this.totalResponses();
    }
    return `${value.value / totalNumberOfResponses * 100}%`;
  };

  render() {
    let PERCENT_OF_COLOR_SHADE_CHANGE = this.props.percentColorShadeChange || 0.4;

    const renderCustomizedLabel = props => {
      const { y, value } = props;

      return (
        <text
          x={5}
          y={y - 10}
          fill={colors.DARK_GRAY}
          textAnchor="right"
          dominantBaseline="middle"
          style={{ fontFamily: 'Circular-Bold' }}
        >
          {value}
        </text>
      );
    };

    return (
      <ResponsiveContainer height={250}>
        <BarChart layout="vertical" data={this.props.results} barCategoryGap={15} barGap={15}>
          <XAxis type="number" allowDecimals={false} hide tickLine={false} />
          <YAxis dataKey="name" type="category" height={75} hide tickLine={false} />
          <CartesianGrid stroke="#fff" />
          <Tooltip />
          <Bar dataKey="response_count">
            {this.props.results.map((entry, index) => {
              return (
                <Cell
                  fill={shadeColor(
                    AccentColor(),
                    PERCENT_OF_COLOR_SHADE_CHANGE / this.props.results.length * index
                  )}
                />
              );
            })}
            <LabelList content={renderCustomizedLabel} offset={200} dataKey="name" />
            <LabelList
              offset={2}
              content={value => this.basicLabel(value)}
              position="right"
              dataKey="response_count"
              style={{ fill: colors.DARK_GRAY }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
